"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryListSectionSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _lodash = _interopRequireDefault(require("lodash.times"));
var _constants = require("../Query/constants");
var _QueryListSection = require("../QueryListSection");
var _styles = require("../QueryListSection/styles");
var _styles2 = require("../SearchPreviewProductSkeleton/styles");
var _constants2 = require("./constants");
var _styles3 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const QueryListSectionSkeleton = ({
  animation = 'pulse',
  className,
  numberOfItems,
  itemTestId = _constants2.QUERY_LIST_SECTION_ITEM_SKELETON
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const rootClassName = (0, _clsx.default)(_QueryListSection.queryListSectionClasses.root, className);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
    className: rootClassName,
    "data-testid": getTestId(_constants2.QUERY_LIST_SECTION_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.SectionLabelSkeleton, {
      className: _QueryListSection.queryListSectionClasses.sectionLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Queries, {
      className: _QueryListSection.queryListSectionClasses.queries,
      children: (0, _lodash.default)(numberOfItems, index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.UnifiedSkeleton, {
        className: _QueryListSection.queryListSectionClasses.query,
        "data-testid": getTestId(itemTestId),
        animation: animation,
        width: 100,
        height: _constants.CHIP_HEIGHT
      }, `${itemTestId}-${index}`))
    })]
  });
};
exports.QueryListSectionSkeleton = QueryListSectionSkeleton;
